import { toSpaceKey } from '@toolproof-core/visualization/_pure/contract-helpers';

export const SPACE_SLUG = 'biology-space' as const;
export const SPACE_KEY = toSpaceKey(SPACE_SLUG);
